// import "./App.css";
import { Route, Routes } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import RestrictedRoute from "./utils/RestrictedRoute";
import Header from "./components/Header";
import Dashboard from "./components/Dashboard";
import Enterprise from "./components/Enterprise";
import Candidate from "./components/Candidate";

function MainApp() {
  const { isAuthenticated } = useContext(AuthContext);
  return (
    <>
      <Header />
      <Routes>
        <Route element={<RestrictedRoute state={isAuthenticated} />}>
          <Route path={"/"} element={<Dashboard />} />
          <Route path={"/enterprise/*"} element={<Enterprise />} />
          <Route path={"/candidate/*"} element={<Candidate />} />
        </Route>
      </Routes>
    </>
  );
}

export default MainApp;
